import { useLocation, useNavigate } from 'react-router-dom';

import Breadcrumbs, { BreadcrumbItem } from '@/components/Breadcrumbs/Breadcrumbs';
import Button from '@/components/Button/Button';

export const SupportPlans = () => {
  const navigate = useNavigate();

  const { pathname: pathName } = useLocation();
  const breadcrumbs: BreadcrumbItem[] = [{ path: pathName, name: '個別支援計画一覧' }];

  const navigateToCreateSupportPlanDraft = (childID: number) => {
    navigate(`/admin/support-plan-drafts/create?childID=${childID}`);
  };

  const navigateToEditSupportPlanDraft = (supportPlanDraftID: number) => {
    navigate(`/admin/support-plan-drafts/${supportPlanDraftID}/edit`);
  };

  const navigateToCreateSupportPlan = (supportPlanDraftID: number, childID: number) => {
    navigate(`/admin/support-plans/create?draftID=${supportPlanDraftID}&childID=${childID}`);
  };

  const navigateToEditSupportPlan = (supportPlanID: number) => {
    navigate(`/admin/support-plans/${supportPlanID}/edit`);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Breadcrumbs item={breadcrumbs} />
      </div>
      {/* 動作確認用でボタンを配置しているだけ */}
      <span>動作確認用に配置しているボタン</span>
      <div className="flex flex-row gap-4">
        <Button
          type="submit"
          size="lg"
          variant="solid-fill"
          onClick={() => navigateToCreateSupportPlanDraft(100018)}
        >
          個別支援計画（案）登録
        </Button>
        <Button
          type="submit"
          size="lg"
          variant="solid-fill"
          onClick={() => navigateToEditSupportPlanDraft(1)}
        >
          個別支援計画（案）編集
        </Button>
        <Button
          type="submit"
          size="lg"
          variant="solid-fill"
          onClick={() => navigateToCreateSupportPlan(1, 100018)}
        >
          個別支援計画登録
        </Button>
        <Button
          type="submit"
          size="lg"
          variant="solid-fill"
          onClick={() => navigateToEditSupportPlan(1)}
        >
          個別支援計画編集
        </Button>
      </div>
    </div>
  );
};
